const Logo = () => <img alt="Logo" src="/static/logo.svg" />;

export default Logo;
